<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="arkCode" label="客户名称/代码" :rules="[{ required: true, message: '请输入' }]">
        <CusSelect
          appId="cos_fbu"
          v-model:value="editForm.arkCode"
          placeholder="请选择"
          @selectData="selectData"
          :disabled="editForm.id"
        />
      </a-form-item>
      <a-form-item name="riskLevel" label="风险程度" :rules="[{ required: true, message: '请输入' }]">
        <a-select ref="select" v-model:value="editForm.riskLevel" placeholder="请选择">
          <a-select-option :value="RISKLEVEL.LOW">低</a-select-option>
          <a-select-option :value="RISKLEVEL.MIDDLE">中</a-select-option>
          <a-select-option :value="RISKLEVEL.HIGH">高</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiLoseWarning, updateBiLoseWarning } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiLoseWarningParams } from '@/typings/api/gucangSale'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { RISKLEVEL } from '../hooks/enum'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiLoseWarningParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiLoseWarningParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, riskLevel } = editForm.value
    const p = {
      arkCode,
      cosId,

      riskLevel
    }
    try {
      if (editForm.value.id) {
        await updateBiLoseWarning({ ...p, id: editForm.value.id })
      } else {
        await addBiLoseWarning(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
